<template lang="pug">
  div.container
    img.header(:src="require('@/assets/test-out-header.png')")
    p.title {{ "Are you already familiar with this topic?" | localize }}
    p.text {{ "To skip this training, test your knowledge with a quiz. To learn more about the topic, start this training." | localize }}
    div.buttons
      button.button(@click="close") {{ "Start Training" | localize }}
      button.button.primary(@click="goToTestout") {{ "Take Quiz" | localize }}
</template>

<script>
import { Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import Scorm from '@bob-the-builder/kb4-scorm-client';
import { mixins } from 'vue-class-component';
import { ThemeConfModule } from '@/store/modules/theme';

const ThemeStore = getModule(ThemeConfModule, store);
const AppState = getModule(AppModule, store);

@Component()
export default class Testout extends mixins(Scorm) {
  created() {
    this.init(ThemeStore.getScormOptions);
  }
  goToTestout () {
    let bookmark = this.getBookmark();
    bookmark.testout = { usedTestout: true, failedTestout: false };  
    this.setBookmark(bookmark);
    
    AppState.setTestout(true);
    this.$emit('close-disclaimer');
  }
  close () {
    AppState.setTestout(false);
    this.$emit('close-disclaimer');
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: $global-padding;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.header {
  max-height: 100px;
}
.title {
  font-size: $font-size-h2;
  font-weight: 600;
  margin: .8em;
}
.text {
  font-size: $font-size-h4;
  font-weight: 400;
  margin: .5em;
}

.button {
  margin: .8rem;
  border-radius: $global-border-radius;
  background-color: #fff;
  font-size: 1.4rem;
  padding: .8rem 1.6rem;
  cursor: pointer;
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 2px solid currentColor;
  &:hover {
    background-color: darken(#fff, 10%);
  }
}
.button.primary {
  color: #fff;
  background-color: $color-primary;
  &:hover {
    background-color: darken($color-primary, 10%);
  }
  &:focus {
    color: darken($color-primary, 5%);
    background-color: #fff;
  }
}
</style>
